import { Spacing } from '@persona-id/design-tokens';
import { ComponentType, ReactNode, SVGAttributes } from 'react';
import styled from 'styled-components';

import Card from 'design-system/components/Card';
import { Paragraph } from 'design-system/components/Text';

const IntegrationHeroCardContentWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  column-gap: ${Spacing[5]};
  max-width: 1000px;
`;

const IntegrationHeroCardDescription = styled('div')`
  flex: 2;
`;

const IntegrationHeroCardImage = styled('div')`
  flex: 1;

  > svg {
    border-radius: 8px;
    width: 100%;
  }
`;

interface IntegrationHeroCardProps {
  title: string;
  image: ComponentType<SVGAttributes<SVGElement>>;
  children: ReactNode;
}

const IntegrationHeroCard = ({ title, image, children }: IntegrationHeroCardProps) => {
  const Image = image;

  return (
    <Card>
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <IntegrationHeroCardContentWrapper>
          <IntegrationHeroCardDescription>
            <Paragraph color='secondary'>{children}</Paragraph>
          </IntegrationHeroCardDescription>
          <IntegrationHeroCardImage>
            <Image />
          </IntegrationHeroCardImage>
        </IntegrationHeroCardContentWrapper>
      </Card.Body>
    </Card>
  );
};

export default IntegrationHeroCard;
